import script from "./EOrganizationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EOrganizationCard.vue?vue&type=script&setup=true&lang=ts"

import "./EOrganizationCard.vue?vue&type=style&index=0&id=64867e59&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64867e59"]])

export default __exports__